import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { map } from 'rxjs/operators';
import { ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RegexToCheckEMail } from '@bo-client/shared/forms/forms.validators';

@Component({
  selector: 'app-contact-details-formpart',
  templateUrl: './contact-details-formpart.component.html',
  styleUrls: ['./contact-details-formpart.component.scss']
})
export class ContactDetailsFormpartComponent implements OnInit {
  @Input() formGroup: ContactDataForm;
  @Input() isRequired = true;
  @Input() differsFromCurrentUser = false;

  #destroyRef = inject(DestroyRef);
  #dataShareService = inject(DataShareService);
  @Input() disable: boolean;

  constructor(private dataShareService: DataShareService) {
    // empty
  }

  ngOnInit() {
    this.initValidators();
  }

  get phoneControl() {
    return this.formGroup.controls.phone;
  }

  get mailControl() {
    return this.formGroup.controls.mail;
  }

  private initValidators() {
    this.#dataShareService.userData$
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        map((userData) => ({
          phone: userData.contactData.phone,
          mails: [userData.mail, userData.contactData.mail]
        }))
      )
      .subscribe((userData) => {
        this.phoneControl.setValidators([
          ...(this.differsFromCurrentUser ? [mustNotMatchUserValidator(userData.phone)] : []),
          Validators.required
        ]);
        this.mailControl.setValidators([
          ...(this.differsFromCurrentUser ? [mustNotMatchUserValidator(userData.mails)] : []),
          validFormatValidator,
          Validators.required
        ]);

        this.phoneControl.updateValueAndValidity();
        this.mailControl.updateValueAndValidity();
      });
  }
}

const mustNotMatchUserValidator = (value: string | (string | null)[] | null): ValidatorFn => {
  return (control: FormControl): ValidationErrors | null => {
    if (!control.value || !value) {
      return null;
    }
    const values = Array.isArray(value) ? value : [value];
    const hasMatch = values.some((value = '') => control.value === value);
    return hasMatch ? { mustNotMatch: true } : null;
  };
};

const validFormatValidator: ValidatorFn = (control: FormControl): ValidationErrors | null => {
  const isValid = RegexToCheckEMail.test(control.value);
  return isValid ? null : { validFormat: true };
};
